import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Typography } from 'antd';
import styled from 'styled-components';
const { Paragraph } = Typography;

export const Wrapper = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  padding-inline-start: 50px;

  @media screen and (max-width: 768px) {
    padding-inline-start: 0px;
  }

  @media screen and (max-width: 640px) {
    padding-inline-start: 0px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
`;
export const HeaderContent = styled.div`
  .title {
    margin: 0;
    color: #1a295a;
    font-size: 20px;
    font-weight: ${FONT_WEIGHT.regular};
  }

  .sub-text {
    margin: 0;
    display: block;
    width: 100%;
    color: #1a295a;
    font-size: 16px;
    font-weight: ${FONT_WEIGHT.light};
  }

  @media screen and (max-width: 768px) {
    .title {
      font-size: 18px;
    }

    .sub-text {
      font-size: 14px;
    }
  }
`;

export const TitleSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-block-start: 24px;

  .title {
    font-weight: ${FONT_WEIGHT.bold};
  }

  &.mb-8 {
    margin-block-end: 8px;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
`;

export const ListWrapper = styled.ul`
  margin-block: 0;
  padding-inline-start: 20px;

  &.normal-number {
    list-style: decimal;
  }
`;

export const ParagraphContent = styled(Paragraph)`
  color: #1a295a;
  font-size: 20px;
  font-weight: ${FONT_WEIGHT.light};
  margin-block-end: 8px !important;

  &.mb-24 {
    margin-block-end: 24px !important;
  }

  &.mb-20 {
    margin-block-end: 20px !important;
  }

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ListItem = styled.li`
  font-size: 20px;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ListTitle = styled.div`
  font-size: 20px;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.regular};

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ListContent = styled.div`
  font-size: 20px;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;
